<div class="items-center" >
  <!-- Backdrop that will show when dropdown is active -->
  <div class="backdrop" [class.backdrop-visible]="isActive"></div>
  
  <div >
    <button
      class="process-button"
      (mouseenter)="isActive = true"
      (mouseleave)="isActive = false"
    >
      <span class="count-text">
        {{ matchedCount }}/{{ totalCount }}
      </span>
      <ion-icon 
        name="chevron-down" 
        class="chevron-icon"
        [class.rotate-180]="isActive"
      ></ion-icon>

      <!-- Dropdown -->
      <div
        class="dropdown"
        [class.dropdown-visible]="isActive"
        [class.dropdown-hidden]="!isActive"
        (mouseenter)="isActive = true"
        (mouseleave)="isActive = false"
      >
        <div class="dropdown-content">
          <div class="process-list">
            <div *ngFor="let process of processTypes; let last = last" 
              class="process-item"
              [class.last-item]="last"
            >
              <ion-icon 
                name="checkmark-circle" 
                class="process-icon"
                [ngClass]="{
                  'matched': process.matched,
                  'not-matched': !process.matched
                }"
              ></ion-icon>
              <div class="process-details">
                <h3 class="process-title">
                  {{ process.processType.toUpperCase() }}
                </h3>
                <p class="process-description">
                  {{ process.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </button>
  </div>
</div>